import { Button, getCanvas, initPointer, Text } from "kontra";
import { Panel, proportionalPlacement } from "../helpers";

export class CongratsPanel {
  private panelElements: any[] = [];
  isShowing = false;
  currentLevel: number;
  private congratsText: Text;

  constructor(parent) {
    initPointer();

    const panel = new Panel(
      getCanvas(),
      0.5,
      0.8,
      proportionalPlacement({ y: .7 }),
      "rgba(0,0,0,0.5)"
    );

    const title = Text({
      text: 'Ass Mangoes',
      font: '34px future_narrow',
      color: '#1ca5fe',
      x: proportionalPlacement({ x: .5 }),
      y: proportionalPlacement({ y: .3 }),
      anchor: { x: 0.5, y: 0.5 },
      textAlign: 'center'
    })

    const subtitle = Text({
      text: 'from Outer Space',
      font: '20px future_narrow',
      color: '#aaa',
      x: proportionalPlacement({ x: .5 }),
      y: proportionalPlacement({ y: .33 }),
      anchor: { x: 0.5, y: 0.5 },
      textAlign: 'center'
    })

    const misclicks = Text({
      text: `You clicked on\n${window.localStorage.getItem('not_impostors_clicked')} mangoes\nby mistake.`,
      font: '24px future_narrow',
      color: '#992233',
      x: proportionalPlacement({ x: .5 }),
      y: proportionalPlacement({ y: .58 }),
      anchor: { x: 0.5, y: 0.5 },
      textAlign: 'center'
    })

    this.congratsText = Text({
      text: 'Congratulations\n on beating \nthe game!',
      font: '24px future_narrow',
      color: '#aaa',
      x: proportionalPlacement({ x: .5 }),
      y: proportionalPlacement({ y: .45 }),
      anchor: { x: 0.5, y: 0.5 },
      textAlign: 'center'
    })

    const button = Button({
      // sprite properties
      x: proportionalPlacement({ x: .5 }),
      y: proportionalPlacement({ y: .7 }),
      anchor: { x: 0.5, y: 0.5 },
      // image: imageAssets['mango'],

      text: {
        text: 'Play\nAgain',
        textAlign: 'center',
        color: '#ee2233',
        font: '28px rocket_square',
        anchor: { x: 0.5, y: 0.5 }
      },

      // pointer events
      onDown() {
        this.x += 2;
        this.y += 5;
      },
      onUp() {
        window.localStorage.setItem('next_starting_level', '1');
        window.localStorage.setItem('not_impostors_clicked', '0');
        this.clicked();
        this.x -= 2;
        this.y -= 5;
      }
    })
    button.clicked = parent.onButtonClick.bind(parent);

    this.panelElements.push(panel, title, subtitle, button, misclicks, this.congratsText)
  }

  show(level) {
    this.currentLevel = level;
    this.isShowing = true;
    this.panelElements.forEach(element => element.show?.())
  }

  clicked() {
    this.isShowing = false;
    this.panelElements.forEach(element => element.hide?.())
  }

  update() {
    if (this.isShowing) {
      this.congratsText.text = `Level ${this.currentLevel}`;
      this.panelElements.forEach(element => element.update?.())
    }
  }

  render() {
    if (this.isShowing) {
      this.panelElements.forEach(element => element.render?.())
    }
  }

}